import { REPORT } from '@consts/reports';
import { hasResellerViewPermission } from '@utils/helper';
import { useSelector } from 'react-redux';
import { LocationsCutLastMonthNotThisMonth } from '@components/reports/issues/LocationsCutLastMonthNotThisMonth';
import { ResellersCutLastMonthNotThisMonth } from '@components/reports/issues/ResellersCutLastMonthNotThisMonth';
import { LocationsNoCutsLastWeek } from '@components/reports/issues/LocationsNoCutsLastWeek';
import { LocationsOverWarrantyRate } from '@components/reports/issues/LocationsOverWarrantyRate';
import { BaseReportPage } from './bases/BaseReportPage';
import { LocationsNoCutsByMaterial } from '@components/reports/issues/LocationsNoCutsByMaterial';
import { Materials } from '@consts/materials';
import { ReportTips } from '@components/ReportTips';

import type { RootState } from '@features/redux/store';

interface IssuesProps {
    showTips: boolean;
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
}

export const Issues = ({ showTips, dateRange, setDateRange }: IssuesProps) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);

    const resellerViewPermitted = hasResellerViewPermission(IdToken);

    return (
        <BaseReportPage dateRange={dateRange} setDateRange={setDateRange} title={'MO Insights Issues'}>
            {showTips && <ReportTips reportType={REPORT.ISSUES_TIPS} />}

            <LocationsCutLastMonthNotThisMonth />

            {resellerViewPermitted && <ResellersCutLastMonthNotThisMonth />}

            <LocationsNoCutsLastWeek />

            <LocationsOverWarrantyRate />

            <LocationsNoCutsByMaterial dateRange={dateRange} material={Materials.Original} />

            <LocationsNoCutsByMaterial dateRange={dateRange} material={Materials.Fusion} />

            <LocationsNoCutsByMaterial dateRange={dateRange} material={Materials.Matte} />

            <LocationsNoCutsByMaterial dateRange={dateRange} material={Materials.StyleSkins} />

            <LocationsNoCutsByMaterial dateRange={dateRange} material={Materials.Pruvia} />
        </BaseReportPage>
    );
};
